import { render, staticRenderFns } from "./seled.vue?vue&type=template&id=5323aa92&scoped=true"
import script from "./seled.vue?vue&type=script&lang=js"
export * from "./seled.vue?vue&type=script&lang=js"
import style0 from "./seled.vue?vue&type=style&index=0&id=5323aa92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323aa92",
  null
  
)

export default component.exports